import createVueComponent from '../createVueComponent';

const ShieldBan = createVueComponent('ShieldBanIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10', key: '1irkt0' }],
  ['path', { d: 'm4 5 14 12', key: '1ta6nf' }],
]);

export default ShieldBan;
